<script setup lang="ts">
import {onMounted, ref} from "vue";
import ChevronBoldIcon from "@/Components/Frontend/Icons/ChevronBoldIcon.vue";

// --- Props
withDefaults(
    defineProps<{
        title?: string | null;
        iconClass?: any;
        animate?: boolean;
        titleClass?: string;
        contentClass?: string;
    }>(),
    {
        title: undefined,
        iconClass: undefined,
        animate: false,
        titleClass: undefined,
        contentClass: undefined,
    },
);
// --- Data
const opened = ref(false);
const useNativeBahaviour = ref(true);
// --- Computed
// --- Methods
const toggle = () => {
    opened.value = !opened.value;
};
onMounted(() => {
    useNativeBahaviour.value = ('open' in document.createElement('details'));
});
// --- Watch
// --- Provide
</script>
<template>
    <details class="ixo-spoiler" @click="toggle" :open="!useNativeBahaviour && opened ? true : undefined">
        <summary class="ixo-spoiler__title" :class="titleClass">
            <slot name="title" :opened="opened">{{ title }}</slot>
            <ChevronBoldIcon class="ixo-spoiler__icon" :class="[iconClass, animate ? 'animate' : '']" />
        </summary>
        <div class="ixo-spoiler__content-wrapper">
            <div class="prose max-w-none ixo-spoiler__content" :class="[contentClass]">
                <slot />
            </div>
        </div>
    </details>
</template>
<style lang="postcss" scoped>
.ixo-spoiler {
    @apply mb-5
    border
    border-[#D3D3D3]
    px-12
    py-5
    hover:cursor-pointer;

    &__icon {
        @apply ml-6
        shrink-0
        origin-center
        font-sans
        text-[22px]
        font-light
        transition
        duration-300;
    }

    &:hover {
        .ixo-spoiler__icon.animate {
            @apply -translate-x-1.5;
        }
    }
}
.ixo-spoiler__title {
    @apply flex
    select-none
    items-center
    justify-between
    text-fsm
    font-light;
}
.ixo-spoiler__content-wrapper {
    @apply grid;
    transition: grid-template-rows 0.2s ease-out;
}
.ixo-spoiler {
    &[open] {
        .ixo-spoiler__content-wrapper {
            @apply duration-200;
            grid-template-rows: 1fr;
        }
        .ixo-spoiler__content {
            @apply opacity-100
            delay-200
            duration-150;
        }
        .ixo-spoiler__icon {
            @apply rotate-90;
        }
    }
    &:not([open]) {
        .ixo-spoiler__content {
            @apply overflow-hidden
            opacity-0;
        }
        .ixo-spoiler__content-wrapper {
            grid-template-rows: 0fr;
        }
    }
}
</style>
